import { createContext, useContext } from 'react';
import { useOwners } from '../hooks/useOwners';
import { jsx as _jsx } from "react/jsx-runtime";
const ownersContext = /*#__PURE__*/createContext(undefined);
export function OwnersProvider(props) {
  const Provider = ownersContext.Provider;
  const owners = useOwners();
  return /*#__PURE__*/_jsx(Provider, {
    value: owners,
    children: props.children
  });
}
export function useOwnersContext() {
  return useContext(ownersContext) || [];
}